import React from 'react';
import { PrimaryButton } from '../../../../components';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import agencyBanner from './agencyBanner.png';
import css from './SectionAgencyHero.module.css';

function AgencyInlineBanner({ intl, onRedirectPage }) {
  return (
    <div className={classNames(css.howItWorks, css.brandInlineBanner)}>
      <div className={css.startContent}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id="AgencyInlineBanner.title" />
            </h2>
            <p>
              <FormattedMessage
                id="AgencyInlineBanner.description"
                values={{
                  nilPremier: intl.formatMessage({
                    id: 'AgencyInlineBanner.nilPremier',
                  }),
                }}
              />
            </p>
            <PrimaryButton
              className={css.viewbtn}
              type="button"
              onClick={() => onRedirectPage('SubscriptionPage')}
            >
              <FormattedMessage id="AgencyInlineBanner.button" />
            </PrimaryButton>
          </div>
        </div>
      </div>
      <div className={css.endContent}>
        <img src={agencyBanner} alt="Agency Banner" className={css.agencyBanner} />
      </div>
    </div>
  );
}

export default AgencyInlineBanner;
